
<!-- header -->
<header class="header">
    <nav class="navbar navbar-expand-lg home-navbar">
        <div class="hmnavflex">
            <div class="sri_logobg">
                <a class="navbar-brand" href="#"><img src="../../assets/image/sri_logo.png" alt="Logo"
                        class="headerlogo"></a>
            </div>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto w-100 justify-content-end clearfix">
                <li class="nav-item actives">
                    <a class="nav-link" href="#"></a>
                </li>
            </ul>
        </div>
        <div class="log">
            <button type="button" class="logout" (click)="logout()" >HOME</button>
        </div>
        <div id="mySidenav" class="sidenav" style="width: 0px;">
            <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">×</a>
            <ul>
                <li><a href="#">HOME</a></li>
                <li><a href="#" class="mobsignup-btn">Sign Up</a></li>
            </ul>
        </div>
        <span class="leftnav">☰ </span>
    </nav>
</header>
<!--end header -->
